<!--
 * @Description: 
 * @Author: wjx
 * @Github: 
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-29 13:49:26
 * @LastEditTime: 2022-05-24 15:04:59
 -->
<template>
  <div id="app">
    <router-view v-if="!closeLoopDebugger" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/qiankun/store';
import { listenRouterChange } from './qiankun/utils/index';

export default {
  name: '',
  computed: {
    ...mapState({
      breadcrumbList: state => state.breadcrumb.breadcrumbList
    }),
    // 获取应用间的store
    ignore() {
      let name = store.getGlobalState('ignore');
      console.log('ignore:', name);
      return name;
    }
  },
  data() {
    return {
      closeLoopDebugger: false
    };
  },
  mounted() {
    // qiankun: 监听路由，获取当前子应用
    listenRouterChange.call(this);
  },
  created() {
    let _this = this;
    window.onbeforeunload = function() {
      sessionStorage.setItem(
        'breadcrumbList',
        JSON.stringify(_this.breadcrumbList)
      );
    };
    // 让你看！！
    let check = function() {
      function doCheck(a) {
        if (('' + a / a)['length'] !== 1 || a % 20 === 0) {
          (function() {}['constructor']('debugger')());
        } else {
          (function() {}['constructor']('debugger')());
        }
        doCheck(++a);
      }
      try {
        doCheck(0);
      } catch (err) {}
    };
    setInterval(_ => {
      let closeLoopDebugger = this.$route.query.closeLoopDebugger;
      if (process.env.NODE_ENV === 'production' && !closeLoopDebugger) {
        // this.closeLoopDebugger = true;
        // check();
      }
    }, 4000);
  }
};
</script>

<style lang="scss">
@import './assets/css/list-page.scss';
@import './assets/css/form-page.scss';
@import './assets/css/media.css';
.el-button--primary {
  background-color: #5a9cf8;
  border-color: #5a9cf8;
}
.hand {
  cursor: pointer;
}
body {
  min-width: 1200px;
}
// 选中
.ysh-active {
  background: #409eff;
  color: #fff;
}

// 单个上传样式
.upload-one {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.el-button {
  line-height: 1 !important;
}
.el-input {
  /*输入框宽度*/
  &.yuan {
    /*输入框后面追加<元>*/
    &:after {
      content: '元';
      margin-left: 10px;
      position: absolute;
    }
  }

  &.percentage {
    /*输入框后面追加<元>*/
    &:after {
      content: '%';
      margin-left: 10px;
      position: absolute;
    }
  }
}
// 放大查看图片
.el-image-viewer__wrapper {
  font-size: 32px;
}
.el-icon-circle-close {
  color: #fff;
}
// 文字提示
.custom-tooltip {
  max-width: 400px;
}
</style>
